import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getSoftwareFromAppIntegration } from '@/features/app-integration/query/api';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
export const Route = createFileRoute('/_staff/app-integrations/import-csv/$id')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  beforeLoad: async ({
    params,
    search
  }) => {
    const software = await getSoftwareFromAppIntegration(params.id);
    throw redirect({
      to: '/software/$id/import-csv',
      params: {
        id: software.id
      },
      search
    });
  }
});